import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HandlerOption, handleServerResponse } from '../directives/server-response-handler';
import { NbToastrService } from '@nebular/theme';
import {ToastReponseEnum} from '../models/enum/toast-reponse.enum';

@Injectable({providedIn: 'root'})
export class BaseService {

  private get defaultHttpPostOptions() {
    return {
      headers: this.createAuthorizationHeader(),
    }
  }

  constructor(
      protected readonly http: HttpClient,
      protected readonly toastr?: NbToastrService,
  ) {}

  createAuthorizationHeader(): HttpHeaders {
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Accept', 'application/json, application/octet-stream');
    headers = headers.append('Content-Type', 'application/json');
    return headers;
  }

  protected get<T>(url: string) {
    return this.http.get(url, {
      headers: this.createAuthorizationHeader(),
    });
  }

  protected post<T>(url: string, data: unknown,
                    toastResponse: ToastReponseEnum = ToastReponseEnum.LESS,
                    options?: HandlerOption): Observable<T> {
    if (toastResponse === ToastReponseEnum.WITH) {
      return this.http.post<T>(url, data, {
        headers: this.createAuthorizationHeader(),
        observe: 'response',
      }).pipe(handleServerResponse(this.toastr, options));
    } else {
      return this.http.post<T>(url, data, {
        headers: this.createAuthorizationHeader(),
      });
    }

  }

  protected postFile<T = object>(url: string, data: FormData): Observable<T> {
    return this.http.post<T>(url, data);
  }

  protected put<T>(url: string, data: unknown,
                   toastResponse: ToastReponseEnum = ToastReponseEnum.LESS,
                   options?: HandlerOption): Observable<T> {
    if (toastResponse === ToastReponseEnum.WITH) {
      return this.http.put<T>(url, data, {
        headers: this.createAuthorizationHeader(),
        observe: 'response',
      }).pipe(handleServerResponse(this.toastr, options));
    } else {
      return this.http.put<T>(url, data, {
        headers: this.createAuthorizationHeader(),
      });
    }
  }

  delete(url: string, toastResponse: ToastReponseEnum = ToastReponseEnum.LESS,
         options?: HandlerOption) {
    if (toastResponse === ToastReponseEnum.WITH) {
      return this.http.delete(url, {
        headers: this.createAuthorizationHeader(),
        observe: 'response',
      }).pipe(handleServerResponse(this.toastr, options));
    } else {
      return this.http.put(url, {
        headers: this.createAuthorizationHeader(),
      });
    }
  }
}
